export class UserOrderModel{
    id: number;
    order_type: string;
    order_num: string;
    total_amount: number;
    sub_total: number;
    order_date: string;
    discount_amount: number;
    shipment_amount: number;
    expert_id: string;
    meals_per_day: string;
    days_per_week: string;
    weeks: string;
    address: string;
    city: string;
    zip: string;
    order_detail: any;
    statusId: any;
    status: any;
    created_at: string;
    to_pay: any;
    check_edit_week: boolean;
    edit_week: string;
    weekly_prices: any[];
    pause_from: string;
    pause_until: string;
    cancel_from: string;
    auto_renew: boolean;

    constructor(){
        this.id = 0;
        this.order_type = '';
        this.order_num = '';
        this.total_amount = 0;
        this.sub_total = 0;
        this.order_date = '';
        this.discount_amount = 0;
        this.shipment_amount = 0;
        this.expert_id = '';
        this.meals_per_day = '';
        this.days_per_week = '';
        this.weeks = '';
        this.address = '';
        this.city = '';
        this.zip = '';
        this.order_detail = [];
        this.created_at = '';
        this.check_edit_week = false;
        this.weekly_prices = [];
        this.auto_renew = true;
    }

    GetDate(date: Date): string {
        const options: Intl.DateTimeFormatOptions = {
          day: 'numeric',
          month: 'numeric',
          year: 'numeric'
        };
        const formattedDate = date.toLocaleDateString('en-GB', options);

        return formattedDate;
      }
}